import { Button, Modal } from "@gotts.ai/ui";

import { useEvmBackend } from "../../context";
import { formatEth as formatEthSmart } from "../../lib/format";

import type { Account } from "./types";

function formatEthFromHex(weiHex: string): string {
  const wei = BigInt(weiHex);
  const eth = Number(wei) / 1e18;
  return formatEthSmart(eth);
}

interface DrainConfirmModalProps {
  account: Account | null;
  onClose: () => void;
  onConfirm: (address: string) => void;
  balances: Record<string, string>;
  drainLoading: string | null;
}

export function DrainConfirmModal({
  account,
  onClose,
  onConfirm,
  balances,
  drainLoading,
}: DrainConfirmModalProps) {
  const { accounts } = useEvmBackend();
  return (
    <Modal
      open={account !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      title="Confirm Drain"
      size="sm"
    >
      {account && (
        <div className="space-y-4">
          <div className="space-y-2">
            <div className="text-text-muted font-mono text-xs uppercase">
              From
            </div>
            <div className="text-text-dim font-mono text-sm">
              {account.label}
            </div>
            <div className="font-mono text-xs text-[var(--color-gold)]">
              {account.address}
            </div>
          </div>

          <div className="space-y-2">
            <div className="text-text-muted font-mono text-xs uppercase">
              To
            </div>
            <div className="text-text-dim font-mono text-sm">Deployer</div>
            <div className="font-mono text-xs text-[var(--color-gold)]">
              {accounts[0]?.address}
            </div>
          </div>

          <div className="space-y-2">
            <div className="text-text-muted font-mono text-xs uppercase">
              Amount
            </div>
            <div className="font-mono text-lg text-[var(--color-success)]">
              ~
              {balances[account.address]
                ? formatEthFromHex(balances[account.address] ?? "0x0")
                : "0"}{" "}
              ETH
            </div>
            <p className="text-text-muted text-[10px]">
              ETH only — ERC-20 tokens remain in account
            </p>
            <p className="text-text-muted text-[10px]">
              Post-drain: ~0 ETH (gas reserved)
            </p>
          </div>

          <div className="flex justify-end gap-2 border-t border-[var(--glass-border)] pt-4">
            <Button variant="ghost" size="sm" onClick={onClose}>
              Cancel
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => {
                onConfirm(account.address);
              }}
              loading={drainLoading === account.address}
              disabled={drainLoading !== null}
              className="btn-danger"
            >
              Drain
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
}
